import PropTypes from "prop-types";
import React, { Fragment, useEffect, useState } from "react";
import MetaTags from "react-meta-tags";

import LayoutOne from "../../layouts/LayoutOne";
import Breadcrumb from "../../wrappers/breadcrumb/Breadcrumb";
import { connect } from "react-redux";
import { fetchUser, saveUser } from "../../redux/actions/userAction";
import { useToasts } from "react-toast-notifications";
import ImageUploader from "react-images-upload";
import {
  changeData,
  fetchAnagraficaWithResult,
  uploadFile,
} from "../../helpers/dbOperations";
import { Link } from "react-router-dom";
import AppBar from "@material-ui/core/AppBar";
import Tab from "@material-ui/core/Tab";
import TabContext from "@material-ui/lab/TabContext";
import TabList from "@material-ui/lab/TabList";
import TabPanel from "@material-ui/lab/TabPanel";
import {
  Box,
  Button,
  makeStyles,
  Paper,
  Tabs,
  Typography,
} from "@material-ui/core";
import MaterialTable from "material-table";
import { fetchAnagrafica, fetchSendCartData } from "../../helpers/dbOperations";
import CustomerModal from "./modals/modalCustomer";
import { Modal } from "react-bootstrap";
import { Article } from "./animationList";
import ReactLoading from "react-loading";

const MyLastPurchases = ({ location, userData, saveUser }) => {
  const useStyles = makeStyles({
    root: {
      flexGrow: 1,
    },
    mymodal: {
      width: "20vw" /* Occupy the 90% of the screen width */,
      maxWidth: "20vw",
    },
  });
  var strings = require("../../translations/italian.json");
  const [value, setValue] = React.useState(0);
  const classes = useStyles();
  const [docs, setDocs] = useState([]);
  const [showModalCustomer, setShowModalCustomer] = useState(false);
  const [modalTitle, setModalTitle] = useState("");
  const [customerArray, setCustomerArray] = useState([]);
  const [onClick, setOnClick] = useState(0);
  const [idCli, setIdCli] = useState(0);
  const [inCaricamentoCheckOut, setinCaricamentoCheckOut] = useState(false);
  const [wait, setWait] = useState(false);
  var informazioni = global.informazioni;

  var _sper = sessionStorage.getItem("personal");
  if (_sper === "undefined") _sper = null;
  const personal = _sper ? JSON.parse(_sper) : {};

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  const SegliAnagrafica = (risultatoAnagrafica) => {
    setModalTitle("Scegli il cliente");
    risultatoAnagrafica.Anagrafica.map((item) => {
      item.value = item.RagSoc;
      item.id = item.IdCli;
      return item;
    });
    setCustomerArray(risultatoAnagrafica.Anagrafica);
    setOnClick(1);
    setShowModalCustomer(true);
  };
  const caricaAnagrafica = async () => {
    //console.log("carica anagrafica")
    var username = userData.user.user.username;
    var password = userData.user.user.password;
    var indexAnagraficaScelta = 0;
    var indexSede = 0;
    var risultatoAnagrafica = {};
    fetchAnagraficaWithResult({ username, password })
      .then((res) => res.json())
      .then((result) => {
        //console.log(result)
        if (!result || !result.Anagrafica) return result;

        if (result.Anagrafica.length > 1) {
          indexAnagraficaScelta = SegliAnagrafica(result);
        } else {
          setIdCli(result.Anagrafica[0].IdCli);
          setCustomerArray(result.Anagrafica);
        }
        return result;
      });
  };
  useEffect(() => {
    setShowModalCustomer(false);
    if (userData.user.user && idCli != 0) {
      var username = userData.user.user.username;
      var password = userData.user.user.password;
      var body = JSON.stringify({ username, password, IDCli: idCli });

      var endpoint = global.endpoint + "pegaso/getLastPurchases";
      fetch(endpoint, {
        method: "POST",
        headers: new Headers({
          "Content-Type": "application/x-www-form-urlencoded",
        }),
        body: body,
        withCredentials: false,
      })
        .then((res) => res.json())
        .then((result) => {
          console.log(result.Docs);
          setDocs(result.Docs);
        });
    }
  }, [idCli]);

  useEffect(() => {
    try {
      if (!userData.user.user.IDCli || userData.user.user.IDCli == 0) {
        //console.log("Agente")
        caricaAnagrafica();
      } else if (userData.user.user && userData.user.user.IDCli != 0) {
        var username = userData.user.user.username;
        var password = userData.user.user.password;
        var body = JSON.stringify({
          username,
          password,
          IDCli: userData.user.user.IDCli,
        });

        var endpoint = global.endpoint + "pegaso/getLastPurchases";
        fetch(endpoint, {
          method: "POST",
          headers: new Headers({
            "Content-Type": "application/x-www-form-urlencoded",
          }),
          body: body,
          withCredentials: false,
        })
          .then((res) => res.json())
          .then((result) => {
            console.log(result.Docs);
            result.Docs = result.Docs.map((item) => {
              var images = JSON.parse(item.IMAGE);

              item.img =
                images.length > 0 ? images[0] : global.placeholderImage;
              return item;
            });

            setDocs(result.Docs);
          });
      }
    } catch (err) {}
  }, []);

  function downloadFile(LIdDoc, CodSezVen, datDoc, numOrd) {
    setWait(true);
    var endpoint = global.endpoint + "pegaso/webAppDocPDF";
    var body = JSON.stringify({ IdDoc: LIdDoc });
    fetch(endpoint, {
      method: "POST",
      headers: new Headers({
        "Content-Type": "application/x-www-form-urlencoded",
      }),
      body: body,
      withCredentials: false,
    })
      .then((res) => res.blob())
      .then((blob) => {
        // 2. Create blob link to download
        const url = window.URL.createObjectURL(new Blob([blob]));
        const link = document.createElement("a");
        link.href = url;
        link.setAttribute("download", `${CodSezVen}_N°${numOrd}_${datDoc}.pdf`);
        // 3. Append to html page
        document.body.appendChild(link);
        // 4. Force download
        link.click();
        // 5. Clean up and remove the link
        link.parentNode.removeChild(link);
        setWait(false);
      });
  }

  function TabPanel(props) {
    const { children, value, index, ...other } = props;

    return (
      <div
        role="tabpanel"
        hidden={value !== index}
        id={`scrollable-auto-tabpanel-${index}`}
        aria-labelledby={`scrollable-auto-tab-${index}`}
        style={{ width: "100%" }}
        {...other}
      >
        {value === index && (
          <Box p={3}>
            <Typography>{children}</Typography>
          </Box>
        )}
      </div>
    );
  }
  function openWindowWithPost(url, data) {
    var form = document.createElement("form");
    form.target = "print_popup";
    form.method = "POST";
    form.action = url;
    form.style.display = "none";
    form.onsubmit =
      "window.open('about:blank','print_popup','width=1000,height=800');";
    for (var key in data) {
      var input = document.createElement("input");
      input.type = "hidden";
      input.name = key;
      input.value = data[key];
      form.appendChild(input);
    }

    document.body.appendChild(form);
    form.submit();
    //window.open(this.href, '_blank', 'width=300,height=200');
    document.body.removeChild(form);
  }
  return (
    <Fragment>
      <MetaTags>
        <title>
          {strings.my_last_purchases} | {informazioni.titleSite}
        </title>
        <meta
          name="description"
          content={strings.my_last_purchases + " " + strings.siteContent}
        />
      </MetaTags>

      <LayoutOne headerTop="invisible">
        {/* breadcrumb 
        <Breadcrumb />*/}

        <CustomerModal
          style={{ zIndex: 10000 }}
          show={showModalCustomer}
          onHide={() => {
            setShowModalCustomer(false);
            setinCaricamentoCheckOut(false);
          }}
          array={customerArray}
          title={modalTitle}
          onClick={setIdCli}
        />
        <div className="login-register-area pt-20">
          <div className="container">
            <div className="row">
              <link
                rel="stylesheet"
                href="https://fonts.googleapis.com/icon?family=Material+Icons"
              />
              <Modal
                show={wait}
                transparent={true}
                dialogClassName={classes.mymodal}
              >
                <div style={{ justifyContent: "center", alignSelf: "center" }}>
                  <Article key={"spinningBubbles"}>
                    <ReactLoading type={"spinningBubbles"} color="#ABABAB" />
                  </Article>
                </div>
              </Modal>
              {(!userData.user.user?.IDCli ||
                userData.user.user?.IDCli == 0) && (
                <div>
                  <Button onClick={() => caricaAnagrafica()}>
                    {" "}
                    Cambia cliente{" "}
                  </Button>
                </div>
              )}
              {/*personal.IDLis && <div style={{justifyContent:"center", display:"flex",width:"100%", marginBottom:"5%"}}>
                {personal.IDLis== 34 && <a href="/files/listino_4super.pdf" style={{padding:"1%", border:"1px dotted black"}}>Visualizza il tuo listino!</a>}
                {personal.IDLis== 33 && <a href="/files/listino_5top.pdf" style={{padding:"1%", border:"1px dotted black"}}>Visualizza il tuo listino!</a>}
                </div>
        */}

              <div style={{}}>
                <MaterialTable
                  localization={{
                    pagination: {
                      labelDisplayedRows: "{from}-{to} di {count}",
                      labelRowsPerPage: "{25,100}",
                      labelRowsSelect: "righe",
                    },
                    toolbar: {
                      nRowsSelected: "{0} riga(e) selezionate",
                      searchTooltip: "Ricerca",
                      searchPlaceholder: "Ricerca",
                    },
                    header: {
                      actions: "Azioni",
                    },
                    body: {
                      emptyDataSourceMessage: "Nessun articolo da visualizzare",
                      filterRow: {
                        filterTooltip: "Filtro",
                      },
                    },
                  }}
                  style={{ width: "1200" }}
                  columns={[
                    {
                      title: "",
                      field: "img",
                      render: (item) => {
                        return (
                          <img src={item.img} alt="" border="3" height="33" />
                        );
                      },
                    },
                    {
                      title: "Cod.Art",
                      field: "sku",
                      type: "text",
                      width: "10%",
                    },
                    { title: "Des.Art", field: "name", width: "30%" },
                    {
                      title: "Ultimo acquisto",
                      field: "UltimaDatDocVen",
                      type: "date",
                      width: "10%",
                    },
                    {
                      title: "Qta",
                      field: "QTAAssociataUltimaDatDocVen",
                      width: "10%",
                    },
                    {
                      title: "Prezzo",
                      field: "Ivato",
                      type: "currency",
                      currencySetting: {
                        locale: "it",
                        currencyCode: "eur",
                        minimumFractionDigits: 2,
                        maximumFractionDigits: 2,
                      },
                    },
                  ]}
                  data={JSON.parse(JSON.stringify(docs))}
                  detailPanel={[
                    {
                      tooltip: "Expand",
                      // render function, same as tableRef.current.props.detailPanel[0].render
                      render: (rowData) => {
                        return (
                          <div>
                            <MaterialTable
                              localization={{
                                pagination: {
                                  labelDisplayedRows: "{from}-{to} di {count}",
                                  labelRowsSelect: "righe",
                                },
                                toolbar: {
                                  nRowsSelected: "{0} riga(e) selezionate",
                                  searchTooltip: "Ricerca",
                                  searchPlaceholder: "Ricerca",
                                },
                                header: {
                                  actions: "Azioni",
                                },
                                body: {
                                  emptyDataSourceMessage:
                                    "Nessun articolo da visualizzare",
                                  filterRow: {
                                    filterTooltip: "Filtro",
                                  },
                                },
                              }}
                              style={{ width: "1200" }}
                              columns={[
                                { title: "Tipo documento", field: "CodSezVen" },
                                {
                                  title: "Num. doc",
                                  field: "PrgDocVen",
                                  width: "10%",
                                },
                                {
                                  title: "Data",
                                  field: "DatDocVen",
                                  type: "date",
                                },
                                {
                                  title: "Qta",
                                  field: "QTA",
                                },
                              ]}
                              data={JSON.parse(rowData.DettaglioMovimenti)}
                              title="Dettaglio articolo"
                              options={{
                                pageSize: 10,
                                // Stile per tutte le celle del corpo della tabella
                                cellStyle: {
                                  paddingTop: "4px", // Riduci il padding superiore
                                  paddingBottom: "4px", // Riduci il padding inferiore
                                  // Puoi anche usare un padding uniforme come '4px 8px' (verticale orizzontale)
                                },
                                // Stile per le celle dell'intestazione della tabella
                                headerStyle: {
                                  paddingTop: "4px", // Riduci il padding superiore
                                  paddingBottom: "4px", // Riduci il padding inferiore
                                  // Per far sì che l'intestazione si allinei con il corpo
                                },
                                // Opzionale: Se vuoi anche impostare un'altezza minima per le righe
                                // rowStyle: {
                                //   minHeight: 30, // Ad esempio, 30px per righe molto strette
                                // },
                              }}
                            />
                          </div>
                        );
                      },
                    },
                  ]}
                  title="Storico acquisti"
                  options={{
                    pageSize: 10,
                    actionsColumnIndex: -1,
                  }}
                />
              </div>
            </div>
          </div>
        </div>
      </LayoutOne>
    </Fragment>
  );
};

MyLastPurchases.propTypes = {
  location: PropTypes.object,
  userData: PropTypes.object,
  cartData: PropTypes.array,
  compareData: PropTypes.array,
  currency: PropTypes.object,
  removeFromCart: PropTypes.func,
  wishlistData: PropTypes.array,
  setToken: PropTypes.func,
};

const mapStateToProps = (state) => {
  return {
    userData: state.userData ? state.userData : [],
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    saveUser: (user, addToast) => {
      dispatch(saveUser(user, addToast));
    },
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(MyLastPurchases);
